<template>
  <div class="add">
    <form-layout>
      <a-form :model="params" ref="formRef" :rules="rules" @finish="submit">
        <a-form-item label="视频封面" :labelCol="{ span: 4 }" name="cover">
          <a-upload
            class="uploader"
            action="https://api.kanbomusic.com/api/public/upload"
            @change="handleChange"
            :before-upload="beforeUpload"
          >
            <img
              v-if="params.cover"
              :src="params.cover"
              alt="avatar"
              class="avatar"
            />
            <div v-else>
              <loading-outlined v-if="loading"></loading-outlined>
              <!-- <plus-outlined v-else></plus-outlined> -->
              <div class="ant-upload-text">请上传不大于2MB的图片</div>
            </div>
          </a-upload>
          <a-input v-model:value="params.cover" class="hide" />
        </a-form-item>
        <a-form-item
          label="标题"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
          name="title"
        >
          <a-input
            size="large"
            placeholder="请输入标题"
            v-model:value="params.title"
          />
        </a-form-item>
        <a-form-item
          label="简介"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
        >
          <a-textarea
            size="large"
            placeholder="请输入简介"
            v-model:value="params.introduction"
            height="240px"
          />
        </a-form-item>
        <a-form-item
          label="视频链接"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
          name="url"
        >
          <a-input
            size="large"
            placeholder="请输入视频链接"
            v-model:value="params.url"
          />
        </a-form-item>
        <!-- <a-form-item label="视频文件" :labelCol="{ span: 4 }" name="url">
          <a-upload
            action="https://api.kanbomusic.com/api/public/upload"
            @change="uploadVideoChange"
            v-model:file-list="imgs"
            accept=".mp4, .mkv, .wma"
          >
            <a-button type="primary" size="large">
              <upload-outlined></upload-outlined>
              上传视频文件
            </a-button>
          </a-upload>

          <a-input v-model:value="params.url" class="hide" />
        </a-form-item> -->
        <a-form-item
          label="创作者"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 10 }"
          name="uid"
        >
          <a-input
            size="large"
            placeholder="请输入创作者"
            v-model:value="params.uid"
          />
        </a-form-item>
      </a-form>
    </form-layout>
    <div class="btns">
      <a-button type="primary" size="large" @click="submit">确定</a-button>
      <a-button size="large" @click="cancel">取消</a-button>
    </div>
  </div>
</template>

<script>
import formLayout from "@/layout/form.vue";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { reactive, toRefs, ref, onMounted } from "vue";
import { message } from "ant-design-vue";
import { beforeUpload } from "@/ulit/index";
import { add, getDetails, update } from "@/api/video";
import { useRouter, useRoute } from "vue-router";
export default {
  setup() {
    const state = reactive({
      loading: false,
      params: {
        cover: "",
        title: "",
        introduction: "",
        url: "",
        uid: "",
      },
      imgs: [],
    });
    const router = useRouter();
    const route = useRoute();
    const formRef = ref();
    const rules = {
      cover: [{ required: true, message: "请上传视频封面", trigger: "blur" }],
      title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      url: [{ required: true, message: "请输入标题", trigger: "blur" }],
       uid: [{ required: true, message: "请输入标题", trigger: "blur" }],
    };
    const handleChange = (info) => {
      if (info.file.status === "uploading") {
        state.loading = true;
        return;
      }
      if (info.file.status === "done") {
        state.params.cover = info.file.response.data.url;
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} 上传失败`);
      }
      state.loading = false;
    };

    const addHandle = () => {
      add(state.params)
        .then((res) => {
          message.success("新增成功");
          router.push("/video");
        })
        .catch(() => {
          message.error("新增失败");
        });
    };
    const updateHandle = () => {
      update(route.params.id, state.params)
        .then((res) => {
          message.success("修改成功");
          router.push("/video");
        })
        .catch(() => {
          message.error("修改失败");
        });
    };
    const submit = () => {
      formRef.value.validate().then((res) => {
        if (route.params.id) {
          updateHandle();
        } else {
          addHandle();
        }
      });
    };
    const init = () => {
      getDetails(route.params.id).then((res) => {
        state.params.cover = res.cover;
        state.params.title = res.title;
        state.params.introduction = res.introduction;
        state.params.url = res.url;
        state.params.uid = res.uid;
        state.params.recommend = res.recommend;
      });
    };
    const cancel = () => {
      router.push("/video");
    };
    onMounted(() => {
      if (route.params.id) {
        init();
      }
    });
    const uploadVideoChange = (info) => {
      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        state.params.url = info.file.response.data.url;
        state.imgs = [{ name: info.file.name }];
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} 上传失败`);
      }
    };
    return {
      PlusOutlined,
      LoadingOutlined,
      formLayout,
      ...toRefs(state),
      rules,
      formRef,
      handleChange,
      beforeUpload,
      submit,
      cancel,
      uploadVideoChange,
    };
  },
};
</script>

<style lang="less">
.add {
  height: 100%;
  .uploader {
    height: 128px;
    width: 128px;
    border: 1px dashed #d9d9d9;
    border-radius: 2px;
    cursor: pointer;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    background-color: #fafafa;
    .ant-upload-list {
      display: none;
    }
  }
  .hide {
    display: none;
  }
  .avatar {
    width: 100%;
    height: 100%;
  }
}
</style>
